
		<section class="section">
			<div class="shell">
				<header class="section__head">
					<h1>About Us & Our Methodology</h1>	
				</header><!-- /.section__head -->

				<div class="section__content">
					<h3>The Four Factors of Trust<sup>&trade;</sup><br><span style="font-size:2rem;font-style: italic;margin-bottom: 2rem;text-transform: none;">Part of Deloitte’s Enterprise Trust Platform</span></h3>

					<p>
						Did you know that trusted companies outperform their peers by up to 400%, that customers who trust a brand are 88% more likely to buy again, and that 79% of employees who trust their employer are more motivated to work (and less likely to leave)? Building trust is your single greatest opportunity to create competitive advantage and earn lifelong loyalty. Trust ultimately comes down to just Four Factors that make up Deloitte's HX TrustID™, a groundbreaking tool poised to become the new gold standard for evaluating organizational performance.
					</p>

					<ul>
						<li>
							<h4 style="color: #006499;">Discover <i>HX TrustID<sup>&trade;</sup> Scores</i></h4>

							<p>
								We have collected over 165K responses across more than 10 industries and we encourage you to immerse yourself in the data with our online trust index. You can discover how trust varies at the industry, sector, and category level as well as by demographic attribute such as ethnicity, background, and age.
							</p>
						</li>

						<li>
							<h4 style="color: #119D9C;">Understand <i>How Trust Impacts Behavior</i></h4>

							<p>
								Did you know that when customers believe a brand is high in Humanity they are 280% more likely to stick with a brand through a mistake?  Or that when customers view an organization as highly capable, they are 380% more likely to spend more on the brand? Use our tool to investigate how the Four Factors of Trust impact customer behavior.
							</p>
						</li>

						<li>
							<h4 style="color: #82B02B;">Quantify <i>the Value of Trust</i></h4>

							<p>
								Use our HX TrustID calculator to quantify the impact improved trust can have on your organization's market value. Simply plug in your estimated market cap and expected stock return. From there, you'll be able to view the expected increase in shareholder returns for adding a single point to your category average trust score.
							</p>
						</li>
					</ul>
				</div><!-- /.section__content -->
			</div><!-- /.shell -->
		</section><!-- /.section -->

		<div class="callout">
			<div class="shell">
				<div class="callout__content">
					<p>
						 Put Trust behind everything you do. Check out the full solution suite of Deloitte’s Enterprise Trust Platform.
					</p>

					<a href="https://www2.deloitte.com/global/en/pages/about-deloitte/solutions/trust.html" target="_blank" class="btn btn--secondary" id="about_us_cta">Learn More</a>
				</div><!-- /.callout__content -->
			</div><!-- /.shell -->
		</div><!-- /.callout -->

		<section class="section section--gray section--primary">
			<div class="shell">
				<h2 class="section__title">Ready to get started? Select your initial view:</h2><!-- /.section__title -->

				<ul class="list-actions">
					<li >
						<a (click)="toggleTab('discover')" class="btn" id="discover_trust_link">Discover Trust Scores</a>
					</li>
					
					<li>
						<a (click)="toggleTab('behavior')" class="btn btn--green-dark" id="impact_behavior_link" >Impact Of Trust On Behavior</a>
					</li>

					<li >
						<a (click)="toggleTab('market')" class="btn btn--green" id="impact_market_value_link" >Impact Of Trust On Market Value</a>
					</li>
				</ul><!-- /.list-actions -->
			</div><!-- /.shell -->
		</section><!-- /.section -->